import PermissionsManagerService from "../../../services/PermissionManagerService";
import { logoutUser } from "../../../actions/authActions";
import Scrollbar from "react-scrollbars-custom";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { connect } from "react-redux";
import "./SideNav.scss";

class SideNav extends Component {

	state = {
		version: '1.5.9'
	}
	//--------------------------EVENTS----------------*/

	onLogoutClick = (e) => {
		this.props.logoutUser(this.props.history);
		window.location.href = "/";
	};

	onActionClick = (link) => {
		window.location.href = link;
	};
	toggleMenu = (e) => {
		let sideNav = document.querySelector(".side");
		sideNav.classList.add("invisibile");

		let hamburger = document.querySelector(".hamburger-top-menu");
		hamburger.classList.add("hamburger-visible");

		let rightSide = document.querySelector(".right");
		rightSide.classList.add("no-side");

		let rightSideRight = document.querySelector(".right-top");
		rightSideRight.classList.add("right-top-visibile");
	};


	//--------------------------CORE_EVENTS----------------*/

	componentDidMount = (e) => {
		const coll = document.getElementsByClassName("collapsible");
		let i;

		for (i = 0; i < coll.length; i++) {
			coll[i].addEventListener("click", function () {
				this.classList.toggle("active");
				let content = this.nextElementSibling;
				if (content.style.display === "block") content.style.display = "none";
				else content.style.display = "block";
			});
		}
		if (!localStorage.getItem('user_id')) {
			localStorage.clear();
			window.location.href = "/";
		}
	};

	render() {
		let roles_v2_array =  PermissionsManagerService.GetMenuByUser(this.props.auth.user);
		const permissions  = roles_v2_array.map((permission, i) => (
			<div key={i} className="sign-out">
				<li className="collapsible" style={{ marginTop: "-15px" }}>
					<i className="material-icons icon">{permission.icon}</i>
					{permission.label}
				</li>
				{roles_v2_array.length > 0 && (
					<ul className="content" style={{ marginTop: "0px" }}>
						{permission.subpermissions.map((subpermission, j) => (
							<li
								key={j}
								onClick={() => this.onActionClick(subpermission.action)}
							>
								<i className="material-icons icon">{subpermission.icon}</i>
								{subpermission.label}
							</li>
						))}
					</ul>
				)}
			</div>
		));

		return (
			<nav className="side">
				<Scrollbar style={{ width: "100%", height: "100%" }}>
					<ul className="top">
						<li>
							<i
								onClick={this.toggleMenu}
								className="material-icons hamburger-side-menu"
							>
								menu
							</i>
						</li>
						{permissions}
						<div className="sign-out" onClick={this.onLogoutClick}>
							<li>
								<i className="material-icons icon">arrow_back</i>Salir
							</li>
						</div>
					</ul>
				</Scrollbar>
				<div style={{ position: "relative" }}>
					<p
						style={{
							position: "absolute",
							bottom: 0,
							right: 20,
							color: "white",
						}}
					>
						{process.env.REACT_APP_ENVIRONMENT} {this.state.version}
					</p>
				</div>
			</nav>
		);
	}
}

const mapStateToProps = (state) => ({
	projects: state.projects,
	user:     state.user,
	auth:     state.auth,
});

export default withRouter(
	connect(mapStateToProps, { logoutUser })(withRouter(SideNav))
);
